var map = {
	"./AVL.png": 4805,
	"./Adobe.png": 583,
	"./Amazon.png": 8976,
	"./Flipkart.png": 5923,
	"./GeekyAnts-logo-profile.jpg": 7245,
	"./Hexaview.jpg": 1275,
	"./Hitachi.jpg": 2184,
	"./IBM.webp": 9942,
	"./Infosys.jpg": 9301,
	"./Jugnoo.png": 4578,
	"./NEWGEN.png": 5972,
	"./Paytm.webp": 1909,
	"./Phonepe.jpg": 9471,
	"./RTDS.jpg": 841,
	"./SILVERPEAK.png": 830,
	"./TCS.webp": 4286,
	"./TOTHENEW.jpg": 1750,
	"./Wipro.jpeg": 3312,
	"./cvent.png": 5620,
	"./google.jpg": 2277,
	"./harman.png": 4235,
	"./images.png": 8662,
	"./img1.jpg": 6526,
	"./img10.jpg": 2420,
	"./img2.jpg": 3257,
	"./img3.jpg": 1564,
	"./img4.jpg": 6407,
	"./img5.jpg": 2570,
	"./img6.jpg": 5173,
	"./img7.jpg": 8008,
	"./img8.jpg": 6147,
	"./img9.jpg": 9686,
	"./indiamart.png": 5551,
	"./innovaccer.png": 2572,
	"./ion.webp": 3946,
	"./jungleworks.png": 2389,
	"./logo.png": 4489,
	"./mainGate.jpg": 4414,
	"./mediaagility.png": 7701,
	"./nagarro.webp": 6822,
	"./oodles.jpg": 2594,
	"./placement Prof. Dr. Ajay s. singholi.png": 2893,
	"./posiit.jpeg": 4221,
	"./rtCamp.webp": 2519,
	"./samsung.webp": 2616,
	"./tata.webp": 9464,
	"./vedanta.png": 5791,
	"./vivo.png": 8386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1370;